import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Lightbulb } from "lucide-react";

const copy = {
  nl: {
    step: "Stap 1",
    title: "Wat ontwerp je?",
    intro: "Beschrijf je doelgroep en ontwerpconcept in 1-2 zinnen voordat je kaarten kiest. Dit geeft de synthetische gebruiker context om op te reageren.",
    exampleLabel: "Voorbeeld:",
    example: '"Een mobiele app die ouderen helpt hun medicatie bij te houden en herinneringen geeft in simpele tekst met groot lettertype."',
    targetGroup: "Doelgroep",
    targetPlaceholder: "Bijvoorbeeld: volwassenen 65+ met chronische pijn",
    concept: "Ontwerpconcept",
    conceptPlaceholder: "Beschrijf je ontwerpconcept hier...",
    characters: "tekens",
    keepGoing: ", ga nog even door!",
    continue: "Doorgaan ->",
  },
  en: {
    step: "Step 1",
    title: "What are you designing?",
    intro: "Before picking cards, describe your target group and design concept in 1-2 sentences. This gives the synthetic user context to react to.",
    exampleLabel: "Example:",
    example: '"A mobile app that helps elderly people track their medication and receive reminders in simple, large-text format."',
    targetGroup: "Target group",
    targetPlaceholder: "For example: adults 65+ with chronic pain",
    concept: "Design concept",
    conceptPlaceholder: "Describe your design concept here...",
    characters: "characters",
    keepGoing: ", keep going!",
    continue: "Continue ->",
  },
};

export function ConceptStep({ concept, setConcept, targetGroup, setTargetGroup, language, onNext }) {
  const ready = concept.trim().length > 10 && targetGroup.trim().length > 2;
  const t = copy[language] || copy.nl;

  return (
    <div className="space-y-5">
      <div className="rounded-2xl border border-black/10 bg-white p-6">
        <div className="flex items-center gap-3 mb-4">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[rgba(144,92,255,0.18)] text-[#905cff]">
            <Lightbulb className="h-5 w-5" />
          </span>
          <div>
            <div className="text-[11px] uppercase tracking-wider text-[#905cff] font-medium">{t.step}</div>
            <h2 className="font-display text-xl font-semibold text-black">{t.title}</h2>
          </div>
        </div>

        <p className="text-sm text-black/60 mb-4 leading-relaxed">
          {t.intro}
        </p>

        <div className="rounded-xl border border-[#905cff]/30 bg-[rgba(144,92,255,0.04)] p-3 mb-4 text-sm text-black/60">
          <strong className="text-black">{t.exampleLabel}</strong> {t.example}
        </div>

        <label className="block text-sm font-medium text-black mb-1">{t.targetGroup}</label>
        <Input
          value={targetGroup}
          onChange={(e) => setTargetGroup(e.target.value)}
          placeholder={t.targetPlaceholder}
          className="rounded-xl mb-4"
        />

        <label className="block text-sm font-medium text-black mb-1">{t.concept}</label>
        <Textarea
          value={concept}
          onChange={(e) => setConcept(e.target.value)}
          placeholder={t.conceptPlaceholder}
          rows={4}
          className="rounded-xl resize-none"
        />

        <div className="mt-2 text-xs text-black/40 text-right">
          {concept.trim().length} {t.characters} {!ready && concept.length > 0 && t.keepGoing}
        </div>
      </div>

      <Button
        onClick={onNext}
        disabled={!ready}
        className="w-full rounded-xl bg-[#905cff] text-white hover:bg-[#5802ff] disabled:opacity-50 py-3"
      >
        {t.continue}
      </Button>
    </div>
  );
}
